import Icon from '../../components/Icon.vue'

Icon.register({"regular/copyright":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56 366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456zM363.4 354.9C353.7 364.6 317.8 396.3 259.3 396.3 176.9 396.3 118.8 334.9 118.8 254.8 118.8 175.6 179.1 115.4 258.6 115.4 314.1 115.4 347.3 142 356.2 150.1A12-12 0 0 0 358.1 165.5L339.9 193.6C336.1 199.5 328 200.9 322.4 196.5 313.8 189.7 290.6 174 260.7 174 212.4 174 182.8 209.3 182.8 254 182.8 295.6 209.7 337.7 261.1 337.7 293.7 337.7 317.9 318.7 326.8 310.5 332.1 305.7 340.4 306.5 344.6 312.2L364.5 339.4A11.9-11.9 0 0 0 363.4 354.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/copyright.js
// module id = pu8g
// module chunks = 0